import React from "react";

export const decreaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    data-testid="decrease-icon"
  >
    <path fill="#000" d="M5 10 0 0h10z" />
  </svg>
);

export const increaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    data-testid="increase-icon"
  >
    <path fill="#000" d="M5 0 0 10h10z" />
  </svg>
);

export const neutralIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="11"
    data-testid="neutral-icon"
  >
    <path
      fill="#000"
      d="M5 11 0 6h10l-5 5ZM5 0l5 5H0l5-5Zm0 9.586L7.586 7H2.414L5 9.586Zm0-8.172L2.414 4h5.172L5 1.414Z"
    />
  </svg>
);
